import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=c3b4f1ec&scoped=true"
import script from "./GroupsTable.vue?vue&type=script&lang=js"
export * from "./GroupsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=c3b4f1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b4f1ec",
  null
  
)

export default component.exports